import React from 'react'
import { mdiAlert } from '@mdi/js'

import { ClaimDeviceH4 } from '../styles'
import {
  ClaimDeviceErrorContainer,
  ClaimDeviceErrorDescription,
  ClaimDeviceErrorIcon,
  ClaimDeviceErrorRetryButton,
  ClaimDeviceErrorSpan,
} from './styles'

interface AlreadyClaimedErrorProps {
  onEraseDataClick: () => void
}

// TODO: Localize
function AlreadyClaimedError({ onEraseDataClick }: AlreadyClaimedErrorProps) {
  return (
    <ClaimDeviceErrorContainer>
      <ClaimDeviceErrorIcon path={mdiAlert} size={2} />
      <ClaimDeviceH4>Device is already claimed</ClaimDeviceH4>
      <ClaimDeviceErrorDescription>
        <ClaimDeviceErrorSpan>
          Please claim another device.
        </ClaimDeviceErrorSpan>
      </ClaimDeviceErrorDescription>
      <ClaimDeviceErrorRetryButton
        variant="primary"
        type="button"
        onClick={onEraseDataClick}
      >
        Claim Another Device
      </ClaimDeviceErrorRetryButton>
    </ClaimDeviceErrorContainer>
  )
}

export default AlreadyClaimedError
